import axios from 'axios';
import type { AxiosInstance } from 'axios';
import { API_BASE_URL } from '@constants/api-url';
import { setupRequestInterceptor } from './interceptors/request';
import { setupResponseInterceptor } from './interceptors/response';
import { tokenRefreshManager } from './token/refresh';

/**
 * API 클라이언트 생성
 */
export const createApiClient = (): AxiosInstance => {
  const client = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true,
  });

  // 토큰 리프레시 매니저에 클라이언트 설정 (순환 참조 방지)
  tokenRefreshManager.setApiClient(client);

  // 인터셉터 설정
  const requestInterceptor = setupRequestInterceptor();
  const responseInterceptor = setupResponseInterceptor(client);

  client.interceptors.request.use(requestInterceptor.onFulfilled, requestInterceptor.onRejected);

  client.interceptors.response.use(responseInterceptor.onFulfilled, responseInterceptor.onRejected);

  return client;
};

// 기본 API 클라이언트 인스턴스
export const apiClient = createApiClient();
